import { Scale, Total } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Dubiel, a tall wall calendar: the year at the foot of its picture; a month's name over its days in two lists, the contact over a picture at its foot. */
export const Dubiel: CalendarDesign = {
  cover: PictureCover({ align: HorizontalAlign.LEFT, at: 0.02, size: 0.22 }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0, 0, 1, 0.2)
    const above = Slice.over(outer, Total(picture.y, picture.height), gap)
    const [contact, rest] = Slice.bottom(above, Scale(short, 0.08), gap)
    const [title, lists] = Slice.top(rest, Scale(short, 0.08), gap)
    return [
      Area.picture(picture, month),
      Area.footer(contact),
      Area.title(title, month, language),
      ...Area.columns(lists, month, year, 2, Scale(lists.width, 0.08)),
    ]
  },
  pages: "month",
}
